import { ServicesClientImpl } from '../../../core/interactors';
import { Locale, LocaleKeys } from '../../../core/locale';
import { ScreenTaskControllerTypes } from '../../../core/navigation';
import { TOverlayOptions } from '../../../core/types';
import { TRecordOverlayParams } from '../../../core/types/TRecordOverlayParams';
import { showOverlayDialog } from '../../overlaydialog/overlaydialog.reducers';
import { setScreenTaskController } from '../../screens/screens.reducers';
import { OverlayTypes } from '../OverlayTypes';
import {
    GLOBAL_MOUSE_TRAP,
    RecordOverlayOptionsType,
} from '../recordoverlay/recordoverlay.reducers';

export type TEmptyRecordOverlayParams = Omit<
    TRecordOverlayParams,
    'offerPreview' | 'showMetadata'
> & {
    isContentAdult: boolean;
    contentTitle: string;
};

export const showEmptyRecordOverlay =
    (params: TEmptyRecordOverlayParams) => async (dispatch: Function) => {
        const { channel, guideCell, isContentAdult, contentTitle } = params;

        const services = new ServicesClientImpl();
        const overlayOptions: Array<TOverlayOptions> = [];

        const shouldHideMetadata = isContentAdult && services.shouldHideMetadata();
        const title = shouldHideMetadata
            ? Locale.getString(LocaleKeys.GUIDE_TITLE_HIDDEN)
            : contentTitle;

        overlayOptions.push({
            text: Locale.getString(LocaleKeys.SEE_MORE_INFO),
            value: {
                actionType: RecordOverlayOptionsType.SEE_MORE_INFO,
                offerId: guideCell?.offerId ?? '',
            },
        });
        overlayOptions.push({
            text: Locale.getString(LocaleKeys.OVERLAY_OPTIONS_SEE_CHANNEL_OPTIONS_TEXT),
            value: { actionType: RecordOverlayOptionsType.SEE_CHANNEL_OPTIONS },
            hrTop: !!overlayOptions.length,
        });

        dispatch(setScreenTaskController(ScreenTaskControllerTypes.RECORD_OVERLAY_TASKS));
        dispatch(
            showOverlayDialog({
                channel,
                hasDimmer: true,
                hasSeperator: false,
                mouseTrapValue: GLOBAL_MOUSE_TRAP,
                options: overlayOptions,
                overlayType: OverlayTypes.RECORD,
                title,
            }),
        );
    };
